// Utility for managing recently viewed videos
const RECENTLY_VIEWED_KEY = 'noilio_recently_viewed';
const MAX_RECENT_ITEMS = 20;

// Get recently viewed videos from localStorage
export const getRecentlyViewed = () => {
  try {
    const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error reading recently viewed videos:', error);
  }
  return [];
};

// Add a video to recently viewed
export const addToRecentlyViewed = (video) => {
  try {
    if (!video || !video.id) return;
    
    const recent = getRecentlyViewed();
    
    // Remove if already exists (to avoid duplicates)
    const filtered = recent.filter(item => item.id !== video.id);
    
    // Add to beginning of array
    const updated = [video, ...filtered];
    
    // Keep only the most recent items
    const limited = updated.slice(0, MAX_RECENT_ITEMS);
    
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(limited));
    
    return limited;
  } catch (error) {
    console.error('Error adding to recently viewed:', error);
    return [];
  }
};

// Clear recently viewed videos
export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(RECENTLY_VIEWED_KEY);
    return [];
  } catch (error) {
    console.error('Error clearing recently viewed:', error);
    return [];
  }
};

// Check if user has viewed any videos
export const hasRecentlyViewed = () => {
  const recent = getRecentlyViewed();
  return recent.length > 0;
};

// Get recently viewed as a collection for display
export const getRecentlyViewedCollection = () => {
  const recent = getRecentlyViewed();
  return {
    title: 'Your Reel',
    items: recent,
    description: 'Continue watching your recently viewed movies'
  };
};
